// @ts-nocheck
import {UsersListHeader} from './components/header/ReportsListHeader'
import {ReportsTable} from './table/ReportsTable'
import {KTCard} from '../../../../_metronic/helpers'
import {useState} from 'react'

const ReportsList = () => {
  const [adSearch, setAdSearch] = useState('')
  const [sDate, setSDate] = useState('')
  const [eDate, setEDate] = useState('')
  const [page, setPage] = useState(1)
  const [status, setStatus] = useState('')
  const [category, setCategory] = useState('')
  return (
    <>
      <KTCard>
        <UsersListHeader
          adSearch={adSearch}
          setAdSearch={setAdSearch}
          sDate={sDate}
          setSDate={setSDate}
          eDate={eDate}
          setEDate={setEDate}
          page={page}
          setPage={setPage}
          status={status}
          setCategory={setCategory}
          setStatus={setStatus}
          category={category}
        />
        <ReportsTable
          adSearch={adSearch}
          //setAdSearch={setAdSearch}
          sDate={sDate}
          setSDate={setSDate}
          eDate={eDate}
          setEDate={setEDate}
          page={page}
          setPage={setPage}
          status={status}
          setStatus={setStatus}
          category={category}
        />
      </KTCard>
      {/* {itemIdForUpdate !== undefined && <UserEditModal />} */}
    </>
  )
}

const ReportsListWrapper = () => <ReportsList />

export {ReportsListWrapper}
